/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Catalog_New_TypeInputs */

const en_task_catalog_new_type = /** @type {(inputs: Task_Catalog_New_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New activity`)
};

const pt_br2_task_catalog_new_type = /** @type {(inputs: Task_Catalog_New_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nova atividade`)
};

/**
* | output |
* | --- |
* | "New activity" |
*
* @param {Task_Catalog_New_TypeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_catalog_new_type = /** @type {((inputs?: Task_Catalog_New_TypeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Catalog_New_TypeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_catalog_new_type(inputs)
	return pt_br2_task_catalog_new_type(inputs)
});